export const CREATE_USER_FORM_CUSTOMER_PO = 'CREATE_USER_FORM_CUSTOMER_PO';

export const FETCH_CUSTOMER_PO_REQUEST = 'FETCH_CUSTOMER_PO_REQUEST';
export const FETCH_CUSTOMER_PO_SUCCESS = 'FETCH_CUSTOMER_PO_SUCCESS';
export const FETCH_CUSTOMER_PO_FAILURE = 'FETCH_CUSTOMER_PO_FAILURE';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const FETCH_CUSTOMER_PO_DELIVERY_AT_REQUEST = 'FETCH_CUSTOMER_PO_DELIVERY_AT_REQUEST';
export const FETCH_CUSTOMER_PO_DELIVERY_AT_SUCCESS = 'FETCH_CUSTOMER_PO_DELIVERY_AT_SUCCESS';
export const FETCH_CUSTOMER_PO_DELIVERY_AT_FAILURE = 'FETCH_CUSTOMER_PO_DELIVERY_AT_FAILURE';

export const CREATE_CUSTOMER_PO_HEADER_REQUEST = 'CREATE_CUSTOMER_PO_HEADER_REQUEST';
export const CREATE_CUSTOMER_PO_HEADER_SUCCESS = 'CREATE_CUSTOMER_PO_HEADER_SUCCESS';
export const CREATE_CUSTOMER_PO_HEADER_FAILURE = 'CREATE_CUSTOMER_PO_HEADER_FAILURE';

export const UPDATE_CUSTOMER_PO_HEADER_REQUEST = 'UPDATE_CUSTOMER_PO_HEADER_REQUEST';
export const UPDATE_CUSTOMER_PO_HEADER_SUCCESS = 'UPDATE_CUSTOMER_PO_HEADER_SUCCESS';
export const UPDATE_CUSTOMER_PO_HEADER_FAILURE = 'UPDATE_CUSTOMER_PO_HEADER_FAILURE';

export const DELETE_CUSTOMER_PO_REQUEST = 'DELETE_CUSTOMER_PO_REQUEST';
export const DELETE_CUSTOMER_PO_SUCCESS = 'DELETE_CUSTOMER_PO_SUCCESS';
export const DELETE_CUSTOMER_PO_FAILURE = 'DELETE_CUSTOMER_PO_FAILURE';

export const FETCH_SINGLE_CUSTOMER_PO_REQUEST = 'FETCH_SINGLE_CUSTOMER_PO_REQUEST';
export const FETCH_SINGLE_CUSTOMER_PO_SUCCESS = 'FETCH_SINGLE_CUSTOMER_PO_SUCCESS';
export const FETCH_SINGLE_CUSTOMER_PO_FAILURE = 'FETCH_SINGLE_CUSTOMER_PO_FAILURE';

export const FETCH_CUSTOMER_PO_INVOICE_REQUEST = 'FETCH_CUSTOMER_PO_INVOICE_REQUEST';
export const FETCH_CUSTOMER_PO_INVOICE_SUCCESS = 'FETCH_CUSTOMER_PO_INVOICE_SUCCESS';
export const FETCH_CUSTOMER_PO_INVOICE_FAILURE = 'FETCH_CUSTOMER_PO_INVOICE_FAILURE';

export const CUSTOMER_PO_USERFORM_RESET = 'CUSTOMER_PO_USERFORM_RESET';

export const NAVIGATE_CUSTOMER_PO_DETAILS = 'NAVIGATE_CUSTOMER_PO_DETAILS';

export const NAVIGATE_CUSTOMER_PO = 'NAVIGATE_CUSTOMER_PO';

export const RESET_CUSTOMER_PO_INVOICE = 'RESET_CUSTOMER_PO_INVOICE';

export const TAB_ACTIVE_KEY = 'TAB_ACTIVE_KEY'
